import { Injectable } from '@angular/core';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { CallHistoryEntryRemoteDto, CallHistoryService } from '../../../../generated/swagger';
import { ReloadCallHistoryForUser } from './samwin-call-history.action';

export interface SamwinCallHistoryStateModel {
   callHistoryForUsers: { [userId: number]: CallHistoryEntryRemoteDto[] };
}

@State<SamwinCallHistoryStateModel>({
   name: 'samwinCallHistory',
   defaults: {
      callHistoryForUsers: {},
   },
})
@Injectable()
export class SamwinCallHistoryState {
   constructor(private callHistoryService: CallHistoryService) {}

   @Selector([SamwinCallHistoryState])
   public static getCallListForUser(state: SamwinCallHistoryStateModel) {
      return (userId: number, numOfEntries: number) => {
         return state.callHistoryForUsers[userId];
      };
   }

   @Action(ReloadCallHistoryForUser)
   @ImmutableContext()
   public reloadCallHistoryForUser(ctx: StateContext<SamwinCallHistoryStateModel>, action: ReloadCallHistoryForUser) {
      return this.callHistoryService
         .getCallHistoryForUser({
            userId: action.userId,
            numOfEntriesToTake: action.numOfEntriesToLoad,
         })
         .pipe(
            map((result) => {
               ctx.setState((state: SamwinCallHistoryStateModel) => {
                  state.callHistoryForUsers[action.userId] = result.data;
                  return state;
               });
            })
         );
   }
}
